import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { clearFilter } from "../components/LocalReceipts/filterConfig";
import apiClient from "../utils/api/apiClient";
import { APIEndpoints } from "../utils/api/apiConfig";
import { PenIcon } from "../components/Icons/PenIcon";
import { StoreIcon } from "../components/Icons/StoreIcon";
import { DeleteIcon } from '../components/Icons/DeleteIcon'
import { makeCall } from '../utils/api/makeCall'
import { isEmptyGuid } from '../utils/emptyGuid'
import axios from "axios";

const CancelToken = axios.CancelToken;
let cancel;

const LocalReceiptsContext = React.createContext({});
export function useLocalReceiptsState() {
  return React.useContext(LocalReceiptsContext);
}
const initialFilter = {
  "filter.receiptName": "",
  "filter.supplierNumber": "",
  "filter.supplierName": "",
};

const LocalReceiptsProvider = ({ children }) => {
  const [/*errorStates*/, setErrorStates] = useState({})
  const [/*loadingStates*/, setLoadingStates] = useState({})
  const [loaded, setLoaded] = useState(false);
  const [pageOffset, setPageOffset] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [showAllLocalReceipts, setShowAllLocalReceipts] = useState(false);
  const [filter, setFilter] = useState(initialFilter);
  const [sorting, setSorting] = useState("displayName");
  const [selectedRow, setSelectedRow] = useState(false);
  const [localReceipts, setLocalReceipts] = useState([]);
  const [tableIsLoading, setTableIsLoading] = useState(false);
  const [showOverlayLeft, setShowOverlayLeft] = useState(false);
  const [filterLocalInventory, setFilterLocalInventory] = useState(null);
  const [forceReloadLocalReceipts, setForceReloadLocalReceipts] =
    useState(false);
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([]);
  const [allCheckBoxesSelected, setAllCheckBoxesSelected] = useState(false);
  const [allSelectedLoading, setAllSelectedLoading] = useState(false);
  const [initialTableId, setInitialTableId] = useState(null);
  const [supplierFilter, setSupplierFilter] = useState(null);
  const [openSupplierFilter, setOpenSupplierFilter] = useState(false);
  const [storehouseFilter, setStorehouseFilter] = useState(null);
  const [openStorehouseFilter, setOpenStorehouseFilter] = useState(false);
  const [openDateRangeFilter, setOpenDateRangeFilter] = useState(false);
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [deleteReceiptId, setDeleteReceiptId] = useState(null);
  const { t } = useTranslation();
  const [lastParams, setLastParams] = useState(
    JSON.stringify({
      pageOffset,
      pageLimit,
      filter,
      showAllLocalReceipts,
      sorting,
    })
  );
  const [filterReceipt, setFilterReceipt] = useState(null);
  const resetFilter = (test = null) => {
    clearFilter();
    setFilter(initialFilter);
    setSupplierFilter(null);
    setStorehouseFilter(null);
    setStartDateFilter(null);
    setEndDateFilter(null);
    if (!showAllLocalReceipts) {
      setLocalReceipts([]);
      setTotalCount(0);
    }
  };
  //when closing OverlayLeft
  const updateOverlayLeftStates = () => {
    supplierFilter ? setOpenSupplierFilter(true) : setOpenSupplierFilter(false);
    storehouseFilter
      ? setOpenStorehouseFilter(true)
      : setOpenStorehouseFilter(false);
    startDateFilter || endDateFilter
      ? setOpenDateRangeFilter(true)
      : setOpenDateRangeFilter(false);
  };
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      "filter.storehouseId": storehouseFilter?.storehouseId || "",
    }));
  }, [storehouseFilter]);
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      "filter.supplierId": supplierFilter?.supplierId || "",
    }));
  }, [supplierFilter]);
  useEffect(() => {
    setFilter((prev) => ({
      ...prev,
      "filter.startDate": startDateFilter || "",
    }));
  }, [startDateFilter]);
  useEffect(() => {
    setFilter((prev) => ({ ...prev, "filter.endDate": endDateFilter || "" }));
  }, [endDateFilter]);

  const handleLocalChangeCheckbox = (id) => {
    if (allCheckBoxesSelected) {
      setAllCheckBoxesSelected(false);
    }
    if (selectedCheckBoxes.includes(id)) {
      var index = selectedCheckBoxes.indexOf(id);
      var newValues = [...selectedCheckBoxes];
      newValues.splice(index, 1);
      setSelectedCheckBoxes(newValues);
    } else {
      setSelectedCheckBoxes((prev) => [...prev, id]);
    }
  };

  //cancel previous calls that are still pending if existing
  const cancelPrevious = () => {
    cancel && cancel();
  };

  const loadLocalReceipts = async () => {
    cancelPrevious();
    const cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    });
    try {
      let params = getParams();
      const response = await apiClient.getJson(
        APIEndpoints.localGoodsReceipts().searchReceipts,
        params,
        true,
        true,
        true,
        { cancelToken }
      );
      if (response.headers["x-total-count"]) {
        setTotalCount(Number(response.headers["x-total-count"]));
      } else {
        setTotalCount(0);
      }
      return response.data;
    } catch (e) {
      if (axios.isCancel(e)) {
        console.log("cancelled by cancelToken");
      }
      return null;
    }
  };

  const getParams = () => {
    const filterWithValues = { ...filter };
    Object.keys(filterWithValues).forEach((filterName) => {
      if (filterWithValues[filterName] === "") {
        delete filterWithValues[filterName];
      }
    });
    let params = { ...filterWithValues };
    params["page.offset"] = pageOffset;
    params["page.limit"] = pageLimit;
    if (sorting) {
      params["sort"] = sorting;
    }
    return params;
  };
  const appendData = (data) => {
    return data.map((item) => ({
      ...item,
      actions: (
        <span>
          <span>
            <Link
              to={`/localstorage/goodsreceipts/${item.id}/edit`}
              onClick={(e) => {
                e.stopPropagation();
              }}
              title={t("employeesPage:editAction")}
            >
              <PenIcon color="#000000" />
            </Link>
          </span>
          <span>
            <Link
              to={`/localstorage/goodsreceipts/${item.id}/store`}
              onClick={(e) => {
                e.stopPropagation();
              }}
              title={t("goodsReceiptsTable:storeAction")}
            >
              <StoreIcon color="#000000" />
            </Link>
          </span>
          <span>
            <Link
              onClick={(e) => {
                e.stopPropagation();
                setDeleteReceiptId(item.id);
              }}
              title={t("delete")}
            >
              <DeleteIcon color="#000000" />
            </Link>
          </span>
        </span>
      ),
      checkBox: (
        <span>
          <input
            type="checkbox"
            id={item.id}
            name="scales"
            checked={selectedCheckBoxes.includes(item.id)}
            onChange={() => {}}
          ></input>
        </span>
      ),
    }));
  };

  useEffect(() => {
    const newParams = JSON.stringify({
      pageOffset,
      pageLimit,
      filter,
      showAllLocalReceipts,
      sorting,
    });
    const filtersHaveChanged =
      JSON.stringify(filter) !== JSON.stringify(JSON.parse(lastParams).filter);
    const sortingHasChanged =
      JSON.stringify(sorting) !==
      JSON.stringify(JSON.parse(lastParams).sorting);
    //go to page 1 if filter or sorting have changed
    if (pageOffset !== 0 && (sortingHasChanged || filtersHaveChanged)) {
      var newParamsFilter = JSON.parse(lastParams);
      newParamsFilter.filter = filter;
      newParamsFilter.sorting = sorting;
      setLastParams(JSON.stringify(newParamsFilter));
      setPageOffset(0);
    } else if (lastParams !== newParams || forceReloadLocalReceipts) {
      setForceReloadLocalReceipts(false);
      setLastParams(newParams);
      (async () => {
        if (
          showAllLocalReceipts ||
          Object.keys(filter).reduce(
            (acc, item) => acc || filter[item] !== "",
            false
          )
        ) {
          setTableIsLoading(true);
          const result = await loadLocalReceipts();
          if (result) {
            // add action icons
            let preparedResult = appendData(result);
            setLocalReceipts(preparedResult);
            setTableIsLoading(false);
          }
        } else {
          cancelPrevious();
          setLocalReceipts([]);
          setTotalCount(0);
          setTableIsLoading(false);
        }
        if (filtersHaveChanged) {
          //setSelectedCheckBoxes([])
          setAllCheckBoxesSelected(false);
        }
      })();
    }
    //eslint-disable-next-line
  }, [
    pageOffset,
    pageLimit,
    filter,
    showAllLocalReceipts,
    sorting,
    forceReloadLocalReceipts,
    setForceReloadLocalReceipts,
  ]);

  const selectAll = () => {
    if (allCheckBoxesSelected || localReceipts.length < 1) {
      setAllCheckBoxesSelected(false);
      setSelectedCheckBoxes([]);
    } else {
      setAllSelectedLoading(true);
      const filterWithValues = { ...filter };
      Object.keys(filterWithValues).forEach((filterName) => {
        if (filterWithValues[filterName] === "") {
          delete filterWithValues[filterName];
        }
      });
      apiClient
        .getJson(APIEndpoints.localGoodsReceipts().searchReceipts, {
          ...filterWithValues,
        })
        .then((result) => {
          if (result) {
            const arrayOfAllIds = result.map((obj) => obj.id);
            setSelectedCheckBoxes(arrayOfAllIds);
          }
        })
        .finally(() => {
          setAllCheckBoxesSelected(true);
          setAllSelectedLoading(false);
        });
    }
  };

  useEffect(() => {
    // add action icons
    // todo only change selected one
    setLocalReceipts((prev) =>
      prev.map((item) => ({
        ...item,
        checkBox: (
          <span>
            <input
              type="checkbox"
              id={item.id}
              name="scales"
              checked={selectedCheckBoxes.includes(item.id)}
              onChange={() => {}}
            ></input>
          </span>
        ),
      }))
    );
  }, [selectedCheckBoxes]);

  const deleteReceipt = async () => {
    if (!isEmptyGuid(deleteReceiptId)) {
      await makeCall('deleteReceipt', async () => {
        await apiClient.deleteJson(APIEndpoints.localGoodsReceipts(deleteReceiptId).plannedReceipts)
      }, setErrorStates, setLoadingStates)
      setForceReloadLocalReceipts(true)
      setShowAllLocalReceipts(true)
    }
    setDeleteReceiptId(null)
  }

  const contextValues = {
    setSelectedCheckBoxes,
    allCheckBoxesSelected,
    selectAll,
    allSelectedLoading,
    selectedCheckBoxes,
    handleLocalChangeCheckbox,
    loaded,
    setLoaded,
    pageOffset,
    setPageOffset,
    pageLimit,
    setPageLimit,
    totalCount,
    setTotalCount,
    showAllLocalReceipts,
    setShowAllLocalReceipts,
    filter,
    setFilter,
    localReceipts,
    setLocalReceipts,
    selectedRow,
    setSelectedRow,
    sorting,
    setSorting,
    resetFilter,
    tableIsLoading,
    showOverlayLeft,
    setShowOverlayLeft,
    filterLocalInventory,
    setFilterLocalInventory,
    forceReloadLocalReceipts,
    setForceReloadLocalReceipts,
    initialTableId,
    setInitialTableId,
    updateOverlayLeftStates,
    supplierFilter,
    setSupplierFilter,
    openSupplierFilter,
    setOpenSupplierFilter,
    storehouseFilter,
    setStorehouseFilter,
    openStorehouseFilter,
    setOpenStorehouseFilter,
    openDateRangeFilter,
    setOpenDateRangeFilter,
    startDateFilter,
    setStartDateFilter,
    endDateFilter,
    setEndDateFilter,
    filterReceipt,
    setFilterReceipt,
    deleteReceiptId, setDeleteReceiptId, deleteReceipt
  };
  return (
    <LocalReceiptsContext.Provider value={contextValues}>
      {children}
    </LocalReceiptsContext.Provider>
  );
};

export default LocalReceiptsProvider;
